import { GADimension } from '@ps/web-core-enums';

import type { LinkClick } from '../events';
import { linkClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

export const linkClicked = (context: TrackingContextValue, data: LinkClick) => {
  GAEvent(
    { label: data.linkText ?? '', action: 'Hyperlink Pressed' },
    context,
    data.resolverTag ? { [GADimension.ResolverTag]: data.resolverTag } : {}
  );

  linkClick(data, context);
};
